import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { TablePagination } from "@mui/material";
import { useHistory } from "react-router-dom";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: "bold",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function UsersTable({ users, searchKey }) {
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const history = useHistory();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  React.useEffect(() => {
    setRows(users);
  }, [users]);

  const filterArray = () =>
    rows?.filter((val) => {
      if (searchKey === "") {
        return val;
      } else if (
        Object.values(val)
          ?.join(" ")
          ?.toLowerCase()
          ?.includes(searchKey?.toLowerCase())
      ) {
        return val;
      }
    });
  return (
    <>
      {filterArray()?.length ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Email</StyledTableCell>
                <StyledTableCell>Account No</StyledTableCell>
                <StyledTableCell>IBAN No</StyledTableCell>
                <StyledTableCell>Created At</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filterArray().length ? (
                filterArray()
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <StyledTableRow
                      key={row.name}
                      sx={{ cursor: "pointer" }}
                      onClick={() => history.push(`/userdetails/${row.userId}`)}
                    >
                      <StyledTableCell
                        component="th"
                        scope="row"
                        sx={{ textTransform: "capitalize" }}
                      >
                        <b>{row.userName ? row.userName : "-"}</b>
                      </StyledTableCell>
                      <StyledTableCell sx={{ textTransform: "capitalize" }}>
                        <b>{row.email ? row.email : "-"}</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.accountNo ? row.accountNo : "-"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.ibanNo ? row.ibanNo : "-"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {" "}
                        {row.createdAt
                          ? new Date(row.createdAt).toLocaleDateString()
                          : "-"}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
              ) : (
                <Typography
                  sx={{ position: "absolute", top: "50%", left: "50%" }}
                >
                  No data found
                </Typography>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Typography component="h1" variant="h6">
            No Data Found
          </Typography>
        </Box>
      )}
      <TablePagination
        component="div"
        count={filterArray()?.length}
        onPageChange={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={false}
      />
    </>
  );
}
